import axios from 'axios';
import { toast } from 'react-toastify';
import { toastConfig } from 'Constants/Config';
import UrlHelper from 'helpers/UrlHelper';

type objectProps = { [k: string]: string[] | string | number | boolean | objectProps };
const jwtToken = undefined
// // const jwtToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiVmlyYWwiLCJ1c2VybmFtZSI6InZpcmFsIiwiYWRtaW4iOmZhbHNlLCJfaWQiOiI2MjBjNzRhYWIxZjQ4ZjcwOWI1ZGRiZWEiLCJpbWFnZSI6Ik5vIGltYWdlIiwiY3VzdG9tZXIiOiJPdGhlcnMiLCJzdGF0dXMiOiJQQUlEIiwic3RvcmFnZSI6NTAwLCJteWNpcmNsZUNsaWVudElkIjoiIiwibXljaXJjbGVDbGllbnRTdWJVc2VySWQiOiIiLCJpc1N1YlVzZXIiOmZhbHNlLCJkZXNpZ25lciI6ZmFsc2UsImRlbW9BY2NvdW50IjpmYWxzZSwiaXNEaXNwbGF5TG9nIjp0cnVlLCJpc0ZyZWVBY2NvdW50IjpmYWxzZSwiaXNBY3RpdmUiOnRydWUsImFkZHJlc3MiOiIiLCJmb2xkZXJJZCI6IjYyMGM3NGFhYjFmNDhmNzA5YjVkZGJmMiIsImFnZSI6NTAsImlhdCI6MTcwNTY2NDgyOSwiZXhwIjoxNzA2MjY5NjI5fQ.u0Y0ktMG5ZO-AbAaUDO79lYaEmSSoNnByM8-tsIdfBs"
axios.defaults.headers.common['Authorization'] = localStorage.getItem("jwtToken") ? `Bearer ${localStorage.getItem("jwtToken")}` : jwtToken;

class CustomMiddleService {

    get = async (path: string, data: objectProps = {}) => {
        try {
            let response = await axios.get(path, { params: data });
            if (response.status === 200) {
                return response.data;
            } else {
                return false;
            }
        }
        catch (error: any) {
            // console.log(error);
            if (error?.response?.data?.message) {
                toast.error(error?.response?.data?.message ? error?.response?.data?.message : 'Something Went Wrong', toastConfig);
            } else {
                console.log("Error in api call:::", error, error?.response)
            }
        }
    }
    getAuth = async (path: string, data: objectProps = {}, headers: any = {}) => {
        try {
            let response = await axios.get(path, { params: data, headers });
            if (response.status === 200) {
                return response.data;
            } else {
                return false;
            }
        }
        catch (error: any) {
            // console.log(error);
            if (error?.response?.data?.message) {
                toast.error(error?.response?.data?.message ? error?.response?.data?.message : 'Something Went Wrong', toastConfig);
            } else {
                console.log("Error in api call:::", error, error?.response)
            }
        }
    }
    post = async (path: string, data: objectProps, headers: objectProps | any = {}) => {
        try {
            let response = await axios.post(path, data, headers);
            if (response.status === 200) {
                return response.data;
            } else {
                return false;
            }
        }
        catch (error: any) {
            if (localStorage.getItem("saveMediaId") && path === UrlHelper.saveMedia) {
                localStorage.removeItem("saveMediaId")
            }
            if (error?.response?.data?.message && path !== UrlHelper.saveMedia && path !== UrlHelper.getCustomerCreditDetails) {
                toast.error(error?.response?.data?.message ? error?.response?.data?.message : 'Something Went Wrong', toastConfig);
            } else {
                console.log("Error in api call:::", error, error?.response)
            }
            // console.error(error);
        }
    }
    postWithProgress = async (path: string, data: objectProps, headers: objectProps | any = {}, onUploadProgress: any = null, onDownloadProgress: any = null) => {
        try {
            let response = await axios.post(path, data, { headers, onUploadProgress, onDownloadProgress });
            if (response.status === 200) {
                return response.data;
            } else {
                return false;
            }
        }
        catch (error: any) {
            if (error?.response?.data?.message) {
                toast.error(error?.response?.data?.message ? error?.response?.data?.message : 'Something Went Wrong', toastConfig);
            } else {
                console.log("Error in api call:::", error, error?.response)
            }

            // console.error(error);
        }
    }

    put = async (path: string, data: objectProps, headers: objectProps | any = {}) => {
        try {
            let response = await axios.put(path, data, headers);
            if (response.status === 200) {
                return response.data;
            } else {
                return false;
            }
        }
        catch (error: any) {
            if (error?.response?.data?.message) {
                toast.error(error?.response?.data?.message ? error?.response?.data?.message : 'Something Went Wrong', toastConfig);
            } else {
                console.log("Error in api call:::", error, error?.response)
            }

            // console.error(error);
        }
    }
    
    delete = async (path: string, data: objectProps = {}, headers: objectProps | any = {}) => {
        try {
            let response = await axios.delete(path, {...headers, ...{ data }});
            if (response.status === 200) {
                return response.data;
            } else {
                return false;
            }
        }
        catch (error: any) {
            if (error?.response?.data?.message) {
                toast.error(error?.response?.data?.message ? error?.response?.data?.message : 'Something Went Wrong', toastConfig);
            } else {
                console.log("Error in api call:::", error, error?.response)
            }

            // console.error(error);
        }
    }

}

const ApisService = new CustomMiddleService();

export default ApisService;
